// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-three-display {
  background-color: #002129;
  max-width: 1000px;
  margin: 0 auto;
  padding: 16px;
}
.top-three-display--mobile {
  padding: 16px 0;
}

.top-three-display-header {
  text-align: center;
  margin-bottom: 16px;
}
.top-three-display-header__text {
  font-weight: 700 !important;
  color: #fff;
  font-size: 32px !important;
}
.top-three-display-header__text--mobile {
  font-size: 14px !important;
}
@media (max-width: 900px) {
  .top-three-display-header {
    margin-bottom: 0;
  }
}

.top-three-display-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}
.top-three-display-body--third {
  margin-bottom: 0;
}

.top-three-display-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-three-display-image {
  width: 72px;
  height: 64px;
  object-fit: contain;
}
.top-three-display-image--second {
  width: 62px;
  height: 56px;
  filter: grayscale(100%);
  color: #D6D6D6;
}
.top-three-display-image--third {
  width: 40px;
  height: 44px;
}
@media (max-width: 900px) {
  .top-three-display-image {
    width: 32px;
    height: 40px;
  }
  .top-three-display-image--second {
    width: 24px;
    height: 30px;
  }
  .top-three-display-image--third {
    width: 20px;
    height: 25px;
  }
}

.top-three-display-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0 16px;
  color: #FFC60A;
}
.top-three-display-text--second {
  color: #D6D6D6;
}
.top-three-display-text--third {
  color: #CD7F32;
}
.top-three-display-text__title {
  font-weight: 700 !important;
  white-space: nowrap;
  font-size: 32px !important;
}
@media (max-width: 900px) {
  .top-three-display-text__title {
    font-size: 20px !important;
  }
}
@media (max-width: 400px) {
  .top-three-display-text__title {
    font-size: 18px !important;
  }
}
.top-three-display-text__title--second {
  font-size: 24px !important;
}
@media (max-width: 900px) {
  .top-three-display-text__title--second {
    font-size: 16px !important;
  }
}
@media (max-width: 400px) {
  .top-three-display-text__title--second {
    font-size: 16px !important;
  }
}
.top-three-display-text__title--third {
  font-size: 18px !important;
}
@media (max-width: 900px) {
  .top-three-display-text__title--third {
    font-size: 14px !important;
  }
}
@media (max-width: 400px) {
  .top-three-display-text__title--third {
    font-size: 14px !important;
  }
}

.top-three-display-footer {
  text-align: center;
  margin-top: 32px;
}
.top-three-display-footer__text {
  font-weight: 700 !important;
  color: #fff;
  font-size: 32px !important;
}
.top-three-display-footer__text--mobile {
  font-size: 14px !important;
}
@media (max-width: 900px) {
  .top-three-display-footer {
    margin-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChampionDisplay/Top3Display.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AACJ;AACI;EACE,eAAA;AACN;;AAGE;EACE,kBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,2BAAA;EACA,WAAA;EACA,0BAAA;AAAN;AAEM;EACE,0BAAA;AAAR;AAII;EAdF;IAeI,gBAAA;EADJ;AACF;;AAIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAGI;EACE,gBAAA;AADN;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;;AAiBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AAdN;AAiBI;EACE,WAAA;EACA,YAAA;AAfN;AAkBI;EAjBF;IAkBI,WAAA;IACA,YAAA;EAfJ;EAiBI;IACE,WAAA;IACA,YAAA;EAfN;EAkBI;IACE,WAAA;IACA,YAAA;EAhBN;AACF;;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAjBJ;AAmBI;EACE,cAAA;AAjBN;AAoBI;EACE,cAAA;AAlBN;AAqBI;EACE,2BAAA;EACA,mBAAA;EACA,0BAAA;AAnBN;AAsBM;EANF;IAOI,0BAAA;EAnBN;AACF;AAsBM;EAXF;IAYI,0BAAA;EAnBN;AACF;AAqBM;EACE,0BAAA;AAnBR;AAsBQ;EAJF;IAKI,0BAAA;EAnBR;AACF;AAsBQ;EATF;IAUI,0BAAA;EAnBR;AACF;AAsBM;EACE,0BAAA;AApBR;AAuBQ;EAJF;IAKI,0BAAA;EApBR;AACF;AAuBQ;EATF;IAUI,0BAAA;EApBR;AACF;;AAyBE;EACE,kBAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,2BAAA;EACA,WAAA;EACA,0BAAA;AAtBN;AAwBM;EACE,0BAAA;AAtBR;AA0BI;EAdF;IAeI,aAAA;EAvBJ;AACF","sourcesContent":[".top-three-display {\n    background-color: #002129;\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 16px;\n  \n    &--mobile {\n      padding: 16px 0;\n    }\n  }\n  \n  .top-three-display-header {\n    text-align: center;\n    margin-bottom: 16px;\n  \n    &__text {\n      font-weight: 700 !important;\n      color: #fff;\n      font-size: 32px !important;\n  \n      &--mobile {\n        font-size: 14px !important;\n      }\n    }\n  \n    @media (max-width: 900px) {\n      margin-bottom: 0;\n    }\n  }\n  \n  .top-three-display-body {\n    display: flex;\n    flex-direction: column; // Stack vertically\n    align-items: center;    // Center horizontally\n    width: 100%;\n    margin-bottom: 16px;\n\n    &--third {\n      margin-bottom: 0;\n    }\n  }\n  \n  .top-three-display-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  \n    // &--first {\n    //   // Styles for the 1st place content\n    // }\n  \n    // &--second {\n    //   height: 70px;\n    // }\n  \n    // &--third {\n    //   height: 60px;\n    // }\n  }\n  \n  .top-three-display-image {\n    width: 72px;\n    height: 64px;\n    object-fit: contain;\n  \n    &--second {\n      width: 62px;\n      height: 56px;\n      filter: grayscale(100%); // Makes it silver\n      color: #D6D6D6; // Silver color\n    }\n  \n    &--third {\n      width: 40px;\n      height: 44px;\n    }\n  \n    @media (max-width: 900px) {\n      width: 32px;\n      height: 40px;\n  \n      &--second {\n        width: 24px;\n        height: 30px;\n      }\n  \n      &--third {\n        width: 20px;\n        height: 25px;\n      }\n    }\n  }\n  \n  .top-three-display-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    margin: 0 16px;\n    color: #FFC60A; // Default color for 1st place\n  \n    &--second {\n      color: #D6D6D6; // Silver color for 2nd place\n    }\n  \n    &--third {\n      color: #CD7F32; // Bronze color for 3rd place\n    }\n  \n    &__title {\n      font-weight: 700 !important;\n      white-space: nowrap;\n      font-size: 32px !important;  // Default size for 1st place\n  \n      // Mobile styles\n      @media (max-width: 900px) {\n        font-size: 20px !important;\n      }\n  \n      // Styles for small mobile\n      @media (max-width: 400px) {\n        font-size: 18px !important;\n      }\n  \n      &--second {\n        font-size: 24px !important;  // 2nd place\n  \n        // Mobile styles\n        @media (max-width: 900px) {\n          font-size: 16px !important;\n        }\n  \n        // Styles for small mobile\n        @media (max-width: 400px) {\n          font-size: 16px !important;\n        }\n      }\n  \n      &--third {\n        font-size: 18px !important;  // 3rd place\n  \n        // Mobile styles\n        @media (max-width: 900px) {\n          font-size: 14px !important;\n        }\n  \n        // Styles for small mobile\n        @media (max-width: 400px) {\n          font-size: 14px !important;\n        }\n      }\n    }\n  }\n  \n  .top-three-display-footer {\n    text-align: center;\n    margin-top: 32px;\n  \n    &__text {\n      font-weight: 700 !important;\n      color: #fff;\n      font-size: 32px !important;\n  \n      &--mobile {\n        font-size: 14px !important;\n      }\n    }\n  \n    @media (max-width: 900px) {\n      margin-top: 0;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
